"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const SelectNonNative = ({ className, classes, children }) => {
    return react_1.default.createElement("div", { className: `${className}` }, children);
};
exports.default = SelectNonNative;
//# sourceMappingURL=SelectNonNative.js.map